import IncomingInstantAdviseSession from 'components/IncomingInstantAdviseSession';
import {
  instantAdviseSessionAccept,
  instantAdviseSessionAssign,
  instantAdviseSessionReject,
} from 'providers/core/instantAdviseSessions';
import React from 'react';
import api from 'services/Api';
import OutHook from 'utils/out-hook';
import routerHistory from 'utils/router-history';

const ASSIGNMENT_INTERVAL = 3000;

class InstantSession {
  isEligible = false;

  _assignMe = async () => {
    try {
      const {assigned, assignedSession, skill} =
        await instantAdviseSessionAssign();
      if (!assigned) {
        this.restartAssignMe();
      } else if (assignedSession) {
        const {id, acceptationDeadline} = assignedSession;

        const deadlineTimeout = setTimeout(
          this.restartAssignMe,
          acceptationDeadline * 1000,
        );

        OutHook.useConfirmModal(
          'درخواست مشاوره فوری',
          <IncomingInstantAdviseSession
            assignedSession={assignedSession}
            skill={skill}
          />,
          async () => {
            try {
              clearTimeout(deadlineTimeout);
              this.pauseAssignMe();
              await instantAdviseSessionAccept(id);
            } catch (e) {
              this.restartAssignMe();
              throw e;
            }
            routerHistory.push(`/app/advise-sessions/${id}`);
          },
          async () => {
            clearTimeout(deadlineTimeout);
            try {
              await instantAdviseSessionReject(id);
            } finally {
              this.restartAssignMe();
            }
          },
          {
            id,
            loadingModal: true,
            noLabel: 'رد کردن',
            yesLabel: 'پذیرفتن',
            hideAfter: acceptationDeadline * 1000,
          },
        );
      } else {
        //Something went wrong but it is safer to restart assignment
        this.restartAssignMe();
      }
    } catch (e) {
      if (e instanceof api.Error) {
        if (e.code === 'NOT_ELIGIBLE') {
          this.isEligible = false;
          return this.pauseAssignMe();
        } else if (e.code === 'RETRY_AFTER') {
          return setTimeout(
            this.restartAssignMe,
            Math.min(
              2147483647,
              Math.max(e.data.interval * 1000 - ASSIGNMENT_INTERVAL, 30 * 1000),
            ),
          );
        }
      }

      this.restartAssignMe();
      throw e;
    }
  };

  resumeAssignMe = () => {
    if (!this.isEligible || this._assignTimeout) {
      return;
    }

    this._assignTimeout = setTimeout(this._assignMe, ASSIGNMENT_INTERVAL);
  };

  pauseAssignMe = () => {
    if (!this._assignTimeout) {
      return;
    }

    clearTimeout(this._assignTimeout);
    this._assignTimeout = undefined;
  };

  restartAssignMe = () => {
    this.pauseAssignMe();
    this.resumeAssignMe();
  };
}

const instantSession = new InstantSession();

export default instantSession;
